export const language: any = {
    OkLogout: "हाँ",
    CloseLogout: "नहीं",
    OkLeave: "त्याग",
    CloseLeave: "रद्द करें",
    LabelPolicy: "गोपनीयता नीति",
    AppName: "Hey! Cooker",
    OnOffNotification: "सूचना चालू/बंद",
    LabelReceiveNotificationSuggestion: "रेसिपी सुझाव सूचनाएं प्राप्त करें",
    LabelReceiveNotifyBreakfast: "दैनिक नाश्ते की सिफारिशें प्राप्त करें",
    LabelReceiveNotifyLunch: "दैनिक दोपहर के भोजन की सिफारिशें प्राप्त करें",
    LabelReceiveNotifyDinner: "दैनिक रात के खाने की सिफारिशें प्राप्त करें",
    notification_history: "सूचना इतिहास",
    readAll: "सभी पढ़ें",
    no_notification: "कोई सूचना इतिहास नहीं",
    labelDisplayName: "प्रदर्शन नाम दर्ज करें",
    placeholderDisplayName: "न्यूनतम 4 अक्षर, अधिकतम 20 अक्षर दर्ज करें",
    changeDisplayName: "प्रदर्शन नाम बदलें",
};